"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBookingPenaltyText = exports.getBookingPenaltyPrices = exports.centsNumberToDollars = exports.StripeCheckoutModes = void 0;
var _constants = require("./constants");
var _roles = require("./roles.utils");
var StripeCheckoutModes = {
  Card: 'card',
  SeparateElements: 'separate-elements'
};
exports.StripeCheckoutModes = StripeCheckoutModes;
var centsNumberToDollars = function centsNumberToDollars(value) {
  return value ? "$".concat(value / 100) : undefined;
};
exports.centsNumberToDollars = centsNumberToDollars;
var getBookingPenaltyPrices = function getBookingPenaltyPrices(isFreeByInsurance) {
  return {
    physicianNoShowPenaltyAmount: isFreeByInsurance ? centsNumberToDollars(_constants.INSURANCE_PHYSICIAN_BOOKING_NO_SHOW_PRICE_AMOUNT) : centsNumberToDollars(_constants.PHYSICIAN_BOOKING_NO_SHOW_PRICE_AMOUNT),
    therapyNoShowPenaltyAmount: isFreeByInsurance ? centsNumberToDollars(_constants.INSURANCE_THERAPY_BOOKING_NO_SHOW_PRICE_AMOUNT) : centsNumberToDollars(_constants.THERAPY_BOOKING_NO_SHOW_PRICE_AMOUNT),
    physicianLateChangePenaltyAmount: isFreeByInsurance ? centsNumberToDollars(_constants.INSURANCE_PHYSICIAN_BOOKING_LATE_CHANGE_PRICE_AMOUNT) : undefined,
    therapyLateChangePenaltyAmount: isFreeByInsurance ? centsNumberToDollars(_constants.INSURANCE_THERAPY_BOOKING_LATE_CHANGE_PRICE_AMOUNT) : undefined,
    lateBookingChangePenaltyNoInsurance: centsNumberToDollars(_constants.BOOKING_LATE_CHANGE_PRICE_AMOUNT)
  };
};
exports.getBookingPenaltyPrices = getBookingPenaltyPrices;
var getBookingPenaltyText = function getBookingPenaltyText(isFreeByInsurance) {
  var isTherapistBooking = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _getBookingPenaltyPri = getBookingPenaltyPrices(isFreeByInsurance),
    therapyNoShowPenaltyAmount = _getBookingPenaltyPri.therapyNoShowPenaltyAmount,
    physicianNoShowPenaltyAmount = _getBookingPenaltyPri.physicianNoShowPenaltyAmount;
  var clinicianRoleText = isTherapistBooking ? (0, _roles.getRoleNameLower)(_roles.UserRoles.Therapist) : (0, _roles.getRoleNameLower)(_roles.UserRoles.Doctor);

  // Disabled while late fees are disabled
  // @Midori
  // return isFreeByInsurance
  //   ? `Monument charges ${
  //       isTherapistBooking ? therapyLateChangePenaltyAmount : physicianLateChangePenaltyAmount
  //     } for late ${clinicianRoleText} appointment changes` +
  //       `(<24 hrs) and ${
  //         isTherapistBooking ? therapyNoShowPenaltyAmount : physicianNoShowPenaltyAmount
  //       } for missed ${clinicianRoleText} appointments.`
  //   : `Missed appointments are not reimbursed, and late changes to an appointment (>24 hours) incur a fee of ${lateBookingChangePenaltyNoInsurance} per appointment.`;
  return isFreeByInsurance ? "Monument charges ".concat(isTherapistBooking ? therapyNoShowPenaltyAmount : physicianNoShowPenaltyAmount, " for missed ").concat(clinicianRoleText, " appointments.") : 'Missed appointments are not reimbursed.';
};
exports.getBookingPenaltyText = getBookingPenaltyText;